module.exports = __webpack_public_path__ + "static/media/Eyebrows_blue.470d3322.svg";